export default {
      id: "change-photo-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#change-photo",
      toString: function () {
        return this.url;
      }
    }